const video = document.querySelectorAll('[data-js-video-autoplay]')

if (video.length) {
  initVideo(video)
}

function isVisible (element, callback) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // eslint-disable-next-line n/no-callback-literal
      callback({ isVisible: entry.isIntersecting })
    })
  })

  observer.observe(element)

  return observer
}

function updateVideoState (video, pauseButton, playText, posterImage = null) {
  const videoHidden = video.classList.contains('is-hidden')

  if (videoHidden) {
    if (posterImage) {
      video.classList.remove('is-hidden')
      posterImage.classList.add('is-hidden')
    }

    if (pauseButton) {
      updateButtonState(pauseButton, 'play', playText)
    }

    video.play().catch(() => {
    })
  } else {
    if (video.paused === false) {
      video.pause()
      video.classList.add('is-paused')

      if (pauseButton) {
        updateButtonState(pauseButton, 'pause', playText)
      }
    } else {
      video.play().catch(() => {
      })

      video.classList.remove('is-paused')

      if (pauseButton) {
        updateButtonState(pauseButton, 'play', playText)
      }
    }
  }
}

function reducedMotion () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)') === true ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches === true) {
    return true
  }
}

function updateButtonState (button, state, playText) {
  const pauseText = button.getAttribute('data-js-pause-text')
  const buttonText = button.querySelector('span')
  const pauseClass = 'video-control--pause'
  const playClass = 'video-control--play'

  if (state === 'play') {
    buttonText.textContent = pauseText
    button.title = pauseText
    button.classList.add(pauseClass)
    button.classList.remove(playClass)
  } else {
    buttonText.textContent = playText
    button.title = playText
    button.classList.add(playClass)
    button.classList.remove(pauseClass)
  }
}

function initVideo (video) {
  video.forEach(video => {
    const pauseButton = video.parentElement.querySelector('[data-js-pause-video]')
    const posterImage = video.parentElement.querySelector('[data-js-video-poster]')
    let playText

    if (pauseButton) {
      playText = pauseButton.querySelector('span').textContent

      pauseButton.addEventListener('click', () => {
        updateVideoState(video, pauseButton, playText, posterImage)
      })
    }

    if (posterImage) {
      posterImage.addEventListener('click', () => {
        updateVideoState(video, pauseButton, playText, posterImage)
      })
    }

    const handleVisibility = () => {
      if (!video.classList.contains('is-paused') && !video.classList.contains('is-hidden')) {
        if (isVisible) {
          video.play()
            .then(() => {
              video.setAttribute('autoplay', 'autoplay')

              if (pauseButton) {
                updateButtonState(pauseButton, 'play', playText)
              }
            })
            .catch(() => {
              if (pauseButton) {
                updateButtonState(pauseButton, 'pause', playText)
              }
            })
        } else {
          if (video.paused === false) {
            video.pause()
          }
        }
      }
    }

    if (reducedMotion()) {
      isVisible(video, handleVisibility)
    } else {
      if (pauseButton) {
        updateButtonState(pauseButton, 'play', playText)
      }

      video.classList.remove('is-paused')

      isVisible(video, handleVisibility)
    }
  }, false)
}
